export const userSelector = {
    user: (state) => state.users.user,
};
export const offlineStorageSelector = {
    device: (state) => state.offlineStorage.device,
};